@if (isChecklistMode() && isCollapsed()) {
    <!-- Modo recolhido (rail): só o % compacto, clicável para expandir -->
    <button
        type="button"
        class="checklist-rail"
        [class.complete]="progress().percent === 100"
        [raTooltip]="{ text: ('document.edit.checklist.completedCount' | translate:{ done: progress().done, total: progress().total }), position: 'right' }"
        (click)="expand()">
        {{ progress().percent }}%
    </button>
}

@if (isChecklistMode() && !isCollapsed()) {
    @if (isComplete()) {
        <!-- Tudo concluído: a trilha inteira verde, animada quando a última etapa
             acabou de ser marcada, e a pergunta sobre avisar os administradores -->
        <div class="checklist-done">
            <div class="done-head">
                <canvas #doneStage class="done-stage" aria-hidden="true"></canvas>
                <div class="done-texts">
                    <span class="done-title">{{ 'document.edit.checklist.allDone' | translate }}</span>
                    <span class="ra-label-xs content-secondary">
                        {{ 'document.edit.checklist.completedCount' | translate:{ done: progress().done, total: progress().total } }}
                    </span>
                </div>
            </div>

            @if (askNotify()) {
                <div class="done-actions">
                    <button type="button" class="notify-button" (click)="onNotify()">
                        {{ 'document.edit.checklist.notifyAdmins' | translate }}
                    </button>
                    <button type="button" class="ghost-button" (click)="askNotify.set(false)">
                        {{ 'document.edit.checklist.notNow' | translate }}
                    </button>
                </div>
            }
            @else if (isResponsible()) {
                <div class="checklist-actions">
                    <button
                        type="button"
                        class="reset-button"
                        [raTooltip]="{ text: ('document.edit.checklist.reset' | translate) }"
                        (click)="onReset()">
                        <ra-icon icon="repeat" varColor="contentSecondary" [size]="16" />
                        <span class="ra-label-xs">{{ 'document.edit.checklist.reset' | translate }}</span>
                    </button>
                </div>
            }
        </div>
    }
    @else {
        <div class="checklist-bar">
            <!-- Progresso: a etapa na trilha + o % granular (pastas contam) -->
            <div class="checklist-progress">
                <div class="progress-head">
                    <span class="step-label">
                        @if (steps().total > 0) {
                            {{ 'document.edit.checklist.step' | translate:{ current: steps().current?.num, total: steps().total } }}
                        }
                        @else {
                            {{ 'document.edit.checklist.completedCount' | translate:{ done: progress().done, total: progress().total } }}
                        }
                    </span>
                    <span class="progress-percent">{{ progress().percent }}%</span>
                </div>
                <div class="progress-track">
                    <div class="progress-fill" [style.width.%]="progress().percent"></div>
                </div>
                @if (steps().current; as next) {
                    <span class="ra-label-xs content-secondary next-label ra-overflow-ellipsis">
                        {{ 'document.edit.checklist.next' | translate }} <strong>{{ next.name }}</strong>
                    </span>
                }
            </div>

            <!-- Reset (só responsáveis, quando há algo concluído) -->
            @if (isResponsible() && progress().done > 0) {
                <div class="checklist-actions">
                    <button
                        type="button"
                        class="reset-button"
                        [raTooltip]="{ text: ('document.edit.checklist.reset' | translate) }"
                        (click)="onReset()">
                        <ra-icon icon="repeat" varColor="contentSecondary" [size]="16" />
                        <span class="ra-label-xs">{{ 'document.edit.checklist.reset' | translate }}</span>
                    </button>
                </div>
            }
        </div>
    }
}
